import Factory from './Factory.js'

const factory = new Factory()

export default factory
